import { useCallback, useEffect, useState } from 'react';
import { Event } from '@/types';
import { EventService } from '@/services/EventService';
import { useApp } from '@/context/AppContext';

export function useProjectEvents(id: string | undefined) {
  const { setEventsList } = useApp();
  const [events, setEvents] = useState<Event[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const reloadEvents = useCallback(async () => {
    try {

      const eventsList = await EventService.getEventsByProjectId(id);
      setEvents(eventsList || []);
      setEventsList(eventsList || []);
      setIsLoading(false);
    } catch (error) {
      // Session lifecycle (401 → refresh/logout) is owned by the global Axios interceptor.
      console.error('Error fetching events:', error);
    }
  }, [id, setEventsList]);

  useEffect(() => {
    if (id) {
      reloadEvents();
    }
  }, [id]);

  return { events, isLoading, reloadEvents };
}
